import React, { useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Form, Input, InputNumber, Spin, message } from "antd";
import { useDispatch } from "react-redux";
import get from "lodash/get";
import { postApi } from "../../redux/rest/restSlice";
import { CREATE_PRICING, UPDATE_PRICING } from "../../constants/actionTypes";
import { PRICING_FIELDS } from "../../constants/pricingTables";

const AddEditPricing = ({ modalInfo, setModalInfo, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const record = get(modalInfo, "data");
  const isEdit = !!record;

  // `pricing_data` is flattened into the form and rebuilt on submit
  const initialValues = isEdit
    ? {
        pricing_name: record.pricing_name,
        ...get(record, "pricing_data", {}),
      }
    : {};

  const onFinish = (values) => {
    const { pricing_name, ...pricingData } = values;

    const payload = {
      pricing_name: pricing_name.trim(),
      pricing_data: pricingData,
    };

    if (isEdit) {
      payload.id = record.id;
    }

    setLoading(true);
    dispatch(
      postApi({
        endpoint: isEdit ? UPDATE_PRICING : CREATE_PRICING,
        payload,
      })
    )
      .then(unwrapResult)
      .then(() => {
        setLoading(false);
        message.success(
          isEdit
            ? "Pricing Updated Successfully !!"
            : "Pricing Created Successfully !!"
        );
        onSuccess();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Spin spinning={loading}>
      <Form
        form={form}
        name="pricing"
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Pricing Name"
          name="pricing_name"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Please enter pricing name",
            },
          ]}
        >
          <Input placeholder="Enter Pricing Name" />
        </Form.Item>

        {PRICING_FIELDS.map(({ key, label, min }) => (
          <Form.Item
            key={key}
            label={label}
            name={key}
            rules={[
              {
                required: true,
                message: `Please enter ${label.toLowerCase()}`,
              },
            ]}
          >
            <InputNumber
              min={min}
              placeholder={`Enter ${label}`}
              style={{ width: "100%" }}
            />
          </Form.Item>
        ))}

        <div className="mt-20 d-flex cabinet-btn">
          <Form.Item>
            <Button
              className="default-secondary-btn"
              onClick={() => {
                setModalInfo();
              }}
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="default-primary-btn"
            >
              {isEdit ? "Update" : "Create"}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Spin>
  );
};

export default AddEditPricing;
